<div class="row">
  <div></div>

  <div class="flex__centered">
    <div class="sub-title">{{ payout().amountCents | centsToDollarsPipe }}</div>
    <rp-finance-status [status]="payout().status" />
  </div>

  <div></div>
</div>

<div class="caption">
  <div class="caption__label">{{ 'finance.id' | translate }}</div>
  <div class="caption__value">{{ payout().id }}</div>
</div>

<div class="caption">
  <div class="caption__label">{{ 'finance.date' | translate }}</div>
  <div class="caption__value">{{ payout().date | date: DateFormat.HourWithSeconds }}</div>
</div>

<div class="caption">
  <div class="caption__label">{{ 'finance.method' | translate }}</div>
  <div class="caption__value">{{ payout().paymentMethodId }}</div>
</div>

<div class="caption">
  <div class="caption__label">{{ 'finance.network' | translate }}</div>
  <div class="caption__value">{{ payout().networkId }}</div>
</div>

<rp-button type="secondary" fullWidth class="offset__top" (click)="openDetails()">
  <rp-icon iconName="eye" size="s" />
  {{ 'finance.statusAndDetails' | translate }}
</rp-button>
